import React from "react";
import "./Switch.css";

const Switch = ({ isOn, handleToggle, disabled, id }) => {
  return (
    <>
      <input
        className="react-switch-checkbox"
        id={id}
        type="checkbox"
        checked={isOn}
        onChange={handleToggle}
        disabled={disabled}
      />
     <label className={`react-switch-label ${isOn ? "on" : "off"}`} htmlFor={id}>
  <span className="react-switch-button" />
</label>

    </>
  );
};

export default Switch;
